import React from 'react';
import '../../../../../../../../../../styles.css';

const QuickButton = ({ button, onQuickButtonClicked }) => {
  return (
    <button className="quick-button" onClick={(event) => onQuickButtonClicked(event, button.value)}>
      {button.label}
    </button>
  );
};

export default QuickButton;
